module.exports = __webpack_public_path__ + "img/25.542ba3de.jpg";